export interface CeidgExtendedReportData {
  taxId: string;
  ceidgId: string;
  name: string;
  businessyAddress: Address;
  additionalBusinessAddresses?: Address[];
  correspondenceAddress?: Address;
  owner: Owner;
  citizenships: Citizenship[];
  pkdCodes?: string[];
  mainPkdCode?: string;
  startDate: Date; // dataRozpoczecia
  suspensionDate: Date | null; // dataZawieszenia
  terminationDate: Date | null; // dataZakonczenia
  removalDate: Date | null; // dataWykreslenia
  resumptionDate: Date | null; // dataWznowienia
  status: CeidgStatus | string;
  statusNumber: number; // numerStatusu
  phoneNumber?: string; // telefon
  email?: string; // email
  website?: string; // www
  electronicDeliveryAddress?: string; // adresDoreczenElektronicznych
  alternativeContactMethod?: string; // innaFormaKonaktu
  maritalPropertyCommunity: MaritalPropertyCommunity;
  maritalPropertyCommunityEndDate?: Date | null; // wspolnoscMajatkowaDataUstania
  deceasedDate?: Date; // dataZgonu
  successionManagementStartDate?: Date; // zarzadSukcesyjnyDataUstanowienia
  successionManagementEndDate?: Date; // zarzadSukcesyjnyDataWygasniecia
  removalLegalBases?: string[]; // podstawyPrawneWykreslenia
  partnership?: Partnership[];
  restrictions?: Restriction[];
  bankruptcy?: Bankruptcy;
  successorAdministrator?: SuccessorAdministrator;
  professionalQualifications?: ProfessionalQualification[];
  authorizations?: Authorizations[];
  businessRestrictions?: BusinessRestrictions[];
  legalCapacityRestrictions?: LegalCapacityRestriction[];
}

export interface Address {
  street: string;
  buildingNumber: string;
  localNumber: string | null;
  postalCode: string;
  city: string;
  country?: string;
  voivodeship?: string;
  county?: string;
  terc?: string;
  simc?: string;
}

export interface Citizenship {
  countryCode: string;
  countryName: string;
}

export interface Owner {
  firstName: string;
  lastName: string;
  taxId: string;
  regonNumber?: string;
}

export interface Partnership {
  taxId: string; // nip
  regon: string; // regon
  suspensionDate: Date | null; // zawieszenia
}

export interface Restriction {
  type: string; // typ
  description: string; // opis
  duration: string; // okres
  issueDate: Date; // dataWydania
  finalDecisionDate: Date; // dataUprawomocnienia
}

export interface Bankruptcy {
  informationType: string; // rodzajInformacji
  rulingDate: Date; // dataOrzeczenia
  firstName: string; // imie
  lastName: string; // nazwisko
  taxId: string;
}

export interface SuccessorAdministrator {
  appointmentDate?: Date; // dataUstanowienia
  firstName: string; // imie
  lastName: string; // nazwisko
  taxId: string; // nip
  citizenship:Citizenship;
  correspondenceAddress?: Address; // adresKorespondencyjny
  email?: string;
  website?: string; // www
  phoneNumber?: string; // telefon
  electronicDeliveryAddress?: string; // adresDoreczenElektronicznych
  alternativeContactMethod?: string; // innaFormaKontaktu
}

export interface ProfessionalQualification {
  examDate: Date; // dataEgzaminu
  invalidationDate?: Date; // dataUniewaznienia
  qualificationType: string; // rodzajKwalifikacji
  profession: string; // zawod
  issuedBy: string; // wydanyPrzez
  professionSymbol: string; // symbolZawodu
  enteredBy: string; // wprowadzonyPrzez
}

export interface Authorizations {
  validFrom: Date; // dataOd
  validTo: Date; // dataDo
  name: string; // nazwa
  description: string; // opis
  enteredBy: string; // wprowadzonePrzez
}

export interface BusinessRestrictions {
  validFrom: Date; // dataOd
  validTo: Date; // dataDo
  name: string; // nazwa
  description: string; // opis
  enteredBy: string; // wprowadzonePrzez
}

export interface LegalCapacityRestriction {
  guardianAppointedDate: Date; // ustanowienieKuratora
  restrictionMode: string; // trybRestrykcji
  restrictionDate: Date; // dataRestrykcji
  enteredBy: string; // wprowadzonePrzez
  guardianFirstName: string; // imie
  guardianLastName: string; // nazwisko
  guardianTaxId: string; // nip
}

export enum CeidgStatus {
  ACTIVE = 'AKTYWNY',
  REMOVED = 'WYKRESLONY',
  SUSPENDED = 'ZAWIESZONY',
  PENDING_START_OF_ACTIVITY = 'OCZEKUJE_NA_ROZPOCZĘCIE_DZIAŁALNOŚCI',
  OPERATES_EXCLUSIVELY_AS_A_COMPANY = 'WYLACZNIE_W_FORMIE_SPOLKI',
  TRANSFERRED_TO_NCR = 'PRZENIESIONY_DO_REJESTRU_PRZEDSIEBIORCOW_KRS',
}

export enum MaritalPropertyCommunity {
  NO = 0,
  YES = 1,
  NOT_APPLICABLE = 2,
}
